import Dashboard from '../../components/Dashboard/dashboard';
import Email from '../User Profile/Email';
import CurrentJobs from '../User Profile/CurrentJobs';
import React, { useState, useEffect } from 'react';
import { CommonUtilities } from '../../commonUtils';
import dashboardService from '../../components/Dashboard/dashboardServices';
import ThemeIndex from '../../components/ThemeCustomization/ThemeIndex';
import 'rc-slider/assets/index.css';
import AuthInitialisation from '../Payment/Tipalti/AuthInitialisation';
import UserProfile from '../User Profile/UserManagement/UserProfile';
import LogChange from '../User Profile/logChange';
import SystemListings from 'components/User Profile/systemListing/systemListingsUI';
import AuditTrail from 'components/User Profile/AuditTrail';
import ClientProfile from 'components/User Profile/Client Profiles/ClientProfile';
import PeriodManagement from 'components/User Profile/PeriodManagement/PeriodManagement';
import UserManagementUI from 'components/User Profile/UserManagement/UserManagementUI';

export default function Navbar() {

    const [pageNumber, setPageNumber] = useState(0);
    var userAccessMenu = JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string).userMenu;
    var liveAccessToken = JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string).liveOption;

    const SubEntities = () => {
        return (
            <div className='hover-box pl pull-right ws-12'>

                {userAccessMenu.map(function (subEntity: any, indexSubEntities: number) {

                    if (subEntity.subEntityType) {
                        return (
                            CommonUtilities.portalSelection(subEntity)
                        );
                    } else {

                        return (
                            <div className='box mb ws-12'>
                                <div className='box-header'>
                                    {subEntity.entityName}
                                    {indexSubEntities === 0 && <Logout />}
                                </div>
                                <div className='box-content'>
                                    {subEntity.subEntities?.map((userMenu: any) => {

                                        if (userMenu.subEntityRef === 201) {
                                            return (
                                                <a href='apps/systemSettings/#/clientProfile' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-user2"></i>
                                                        <span className="m0 pts ">Client Profile</span>
                                                    </div>
                                                </a>);


                                            /*return <ClientProfile />*/
                                        } else if (userMenu.subEntityRef === 202) {
                                            return <CurrentJobs />
                                        } else if (userMenu.subEntityRef === 203) {
                                            return (
                                                <div className={"box-primary ms text-center iconLogo pull-left  mrl"}>
                                                    <i className="box icon-mail" onClick={() => { setopenEmailFeed(true); }}></i>
                                                    <span className="m0 pts ">Email Feed</span>
                                                </div>
                                            )
                                        } else if (userMenu.subEntityRef === 204) {
                                            /* return (
                                                <a href='apps/systemSettings/#/auditTrail' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-line-chart"></i>
                                                        <span className="m0 pts ">Audit Trail</span>
                                                    </div>
                                                </a>);*/
                                            return <AuditTrail />
                                        } else if (userMenu.subEntityRef === 205) {
                                            return (
                                                <a href='apps/userManagement/#/register' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-contacts"></i>
                                                        <span className="m0 pts ">User Management </span>
                                                    </div>
                                                </a>);
                                            /*return <UserManagementUI />*/
                                        } else if (userMenu.subEntityRef === 206) {
                                            return (
                                                <a href='apps/systemSettings/#/periodMGT' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-calendar5"></i>
                                                        <span className="m0 pts ">Period Management </span>
                                                    </div>
                                                </a>);
                                            /* return <PeriodManagement />*/
                                        } else if (userMenu.subEntityRef === 207) {
                                            return (
                                                <a href='apps/systemSettings/#/controlPanel' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-settings1"></i>
                                                        <span className="m0 pts ">Control Pannel</span>
                                                    </div>
                                                </a>);

                                        } else if (userMenu.subEntityRef === 208) {
                                            return (
                                                <a href='apps/systemListings/#/' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-stack2"></i>
                                                        <span className="m0 pts ">System Listing</span>
                                                    </div>
                                                </a>);
                                            /*return <SystemListings /> */
                                        } else if (userMenu.subEntityRef === 209) {
                                            return (
                                                <a href='../../' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-refresh"></i>
                                                        <span className="m0 pts ">Recycle Pool</span>
                                                    </div>
                                                </a>);
                                        } else if (userMenu.subEntityRef === 210) {
                                            return (
                                                <a href='../../' className="pull-left">
                                                    <div className="box-primary ms text-center iconLogo pull-left  mrl">
                                                        <i className="box icon-refresh1"></i>
                                                        <span className="m0 pts ">Refresh</span>
                                                    </div>
                                                </a>);
                                        } else if (userMenu.subEntityRef === 26) {

                                            return (
                                                <div className={"box-primary ms text-center iconLogo pull-left  mrl"}>
                                                    <i className="box icon-dollar1" onClick={() => { openUi(userMenu.subEntityRef); }}></i>
                                                    <span className="m0 pts ">Tipalti</span>
                                                </div>
                                            )
                                        } else if (userMenu.subEntityRef === 30) {

                                            return (
                                                <div className={"box-primary ms text-center iconLogo pull-left  mrl"}>
                                                    <i className="box icon-edit2" onClick={() => { openUi(userMenu.subEntityRef); }}></i>
                                                    <span className="m0 pts ">Edit Logs</span>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            </div>
                        );
                    }
                })}

                <div className="box-primary text-center iconLogo pull-right hide">
                    <a href="/apps/index.html">
                        <div className="ws-12">
                            <i className="box pm icon-user2"></i>
                            Profile
                        </div>
                    </a>
                </div>
            </div>
        )
    }

    const LiveAccess = () => {
        if (liveAccessToken) {
            return (
                <div className="box-primary text-center iconLogo pull-right">
                    <a href="/apps/index.html">
                        <div className="ws-12">
                            <i className="box pm icon-broadcast"></i>
                            Live
                        </div>
                    </a>
                </div>
            )
        } else {
            return (<></>);
        }
    }

    const Logout = () => {
        return (
            <button className='btn-purple pull-right btn-xxs' onClick={CommonUtilities.clearAuthToken}>
                <i className="icon-stand-by"></i>
                <span className='ml mr'>
                    Logout
                </span>
            </button>)
    }

    const handleRecyclePool = () => {
        dashboardService.recyclePool().then((res: any) => {
            console.log('API response:', res)
        })
            .catch(error => {
                console.log('API CALL ERROR', error);
            });
    }

    const [openEmailFeed, setopenEmailFeed] = useState(false);
    const EmailFeedClose = (e: any) => {
        setopenEmailFeed(false)
    }

    const [openSubEntities, setSubEntities] = useState(0);
    const openUi = (e: any) => {
        console.log(e)
        setSubEntities(e)
    }

    const closeUIPanel = (e: any) => {
        setSubEntities(0)
    }

    return (
        <div className='pull-right' >

            <div className="hover-box pl pull-right" >

                <button className='btn-purple pull-right hide'>
                    <i className="icon-menu text-l width-auto pull-right mr btn-xs" onClick={CommonUtilities.clearAuthToken}></i>
                </button>

                <div className="box-primary text-center iconLogo pull-right">
                    <a href="/apps/index.html">
                        <div className="ws-12">
                            <i className="box pm icon-menu"></i>
                            Menu
                        </div>
                    </a>
                </div>

                <ul className="hover-block rightReset landing ws-6 pull-left mr" ><Dashboard openNav={true} /></ul>

            </div>

            <div className="hover-box pl pull-right" >
                <div className="box-primary text-center iconLogo pull-right">
                    <a href="/apps/index.html">
                        <div className="ws-12">
                            <i className="box pm icon-user2"></i>
                            Profile
                        </div>
                    </a>
                </div>

                <ul className="hover-block rightReset landing ws-6 pull-left mr">
                    <SubEntities></SubEntities>
                </ul>
            </div>

            <UserProfile />
            <LiveAccess></LiveAccess>
            <ThemeIndex></ThemeIndex>

            {(() => {

                if (openEmailFeed) {
                    return <Email openEmailFeed={openEmailFeed} EmailFeedClose={EmailFeedClose} />;
                }

                if (openSubEntities === 26) {
                    return (<AuthInitialisation openUI={true} closeUI={closeUIPanel} />);
                }

                if (openSubEntities === 30) {
                    return (<LogChange openUI={true} closeUI={closeUIPanel} />);
                }

                if (openSubEntities === 208) {
                    return (<SystemListings />);
                }
            })()}
        </div>
    )
}